import { Toast } from '@easyvaas/js-components';
import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useClosePopup } from '../../hooks/useClosePopup';
import { imagesV3Data, presentProp } from '../../services';
import { materialItemSelector } from '../../store/selector';
import { imagePopupState } from '../../store/state';
import ImageOpreationPopoup from '../ImageOpreationPopup';
import NumberInput from '../NumberInput';
import styles from './index.module.scss';
const PresentPopup = () => {
  const { target, visible } = useRecoilValue(imagePopupState('present'));
  const item = useRecoilValue(materialItemSelector(target));
  const [number, setNumber] = useState('');
  const [name, setName] = useState('');
  const closePopup = useClosePopup();
  const onClick = async () => {
    try {
      if (!item || !name || !number) {
        Toast('请完善信息');
        return;
      }
      Toast.loading('赠送中...');
      await presentProp({
        toolId: item.toolId,
        name: Number(name),
        number: Number(number),
        chipType: item.toolId === 0 ? 1 : 2
      });
      await imagesV3Data.refresh({});
      closePopup('present');
      Toast('赠送成功');
    } catch ({ message }) {
      Toast(message);
    }
  };
  useEffect(() => {
    if (visible) {
      setName('');
      setNumber('');
    }
  }, [visible]);
  if (!item) return null;
  return (
    <ImageOpreationPopoup
      type="present"
      title="赠送"
      className={styles.container}
      onClick={onClick}
    >
      <div className={styles.field}>
        <label>受赠ID</label>
        <input
          type="number"
          value={name}
          onChange={e => setName(e.target.value)}
        />
      </div>
      <div className={styles.field}>
        <label>数量</label>
        <NumberInput value={number} onChange={setNumber} max={item.number} />
      </div>
    </ImageOpreationPopoup>
  );
};

export default React.memo(PresentPopup);
